import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cityDetailStatistics from '@/views/platformReport/components/cityDetailStatistics.vue';
import provinceDetailStatistics from '@/views/platformReport/components/provinceDetailStatistics.vue';
export default {
  components: {
    cityDetailStatistics: cityDetailStatistics,
    provinceDetailStatistics: provinceDetailStatistics
  },
  props: {
    /**
     * entry 入口类型
     * platformReport - 平台报表-订单消费统计
     * abnormalOrderMonitor - 平台报表-异常订单监控
     * orderListDetail - 订单列表-订单详情
    */
    entry: {
      type: String,
      default: function _default() {
        return 'platformReport';
      }
    },
    /**
     * originParams 原始参数
    */
    originParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      tabsName: '2',
      tabsConfig: [{
        name: '2',
        label: '下单省份',
        tips: '以用户购买商品/服务所在省份为单位，汇总通过当前菜单生成的订单数、消费点数、消费占比、成本、成本率'
      }, {
        name: '1',
        label: '下单城市',
        tips: '以用户购买商品/服务所在城市为单位，汇总通过当前菜单生成的订单数、消费点数、消费占比、成本、成本率'
      }]
    };
  },
  mounted: function mounted() {
    this.handleResetData();
    this.handleClickTab({
      name: '2'
    });
  },
  methods: {
    handleResetData: function handleResetData() {
      this.tabsName = '2';
    },
    handleClickTab: function handleClickTab(tab) {
      var _this = this;
      if (tab.name === '2') {
        // 下单省份
        this.$nextTick(function () {
          _this.$refs.provinceDetailStatistics && _this.$refs.provinceDetailStatistics.refreshData();
        });
      } else if (tab.name === '1') {
        // 下单城市
        this.$nextTick(function () {
          _this.$refs.cityDetailStatistics && _this.$refs.cityDetailStatistics.refreshData();
        });
      }
    },
    // 下单省份 - 点击省份跳转到下单城市
    onJumpCityStatistics: function onJumpCityStatistics(provinceCode) {
      var _this2 = this;
      this.tabsName = '1';
      this.$nextTick(function () {
        _this2.$refs.cityDetailStatistics && _this2.$refs.cityDetailStatistics.jumpWithProvince(provinceCode);
      });
    }
  }
};